import * as DOM from "./DOMHelpers";

document.addEventListener("DOMContentLoaded", function() {
    initialize();
});

type state = {
    basket: HTMLFormElement,
};

function initialize() {
    let basket = <HTMLFormElement|null>document.querySelector('[data-basket="container"]');

    if(basket === null) {
        return ;
    }

    initializeGifts(basket);

    basket.addEventListener('click', function(e) {
        let htmlTarget = e.target

        if(htmlTarget instanceof HTMLElement) {
            let changeGiftButton = DOM.getMatched(htmlTarget, '[data-basket="change-gifts"]');

            if(changeGiftButton) {
                e.preventDefault();
                changeGifts(<HTMLElement>DOM.getMatched(changeGiftButton, '[data-basket="item-container"]'));
                return;
            }

            let minusBtn = DOM.getMatched(htmlTarget, '[data-basket="minus-gift"]');

            if(minusBtn) {
                e.preventDefault();
                subGift(
                    <HTMLElement>DOM.getMatched(minusBtn, '[data-basket="item-container"]'),
                    <HTMLElement>DOM.getMatched(minusBtn, '[data-basket="gift"]')
                );
                return;
            }

            let plusBtn = DOM.getMatched(htmlTarget, '[data-basket="plus-gift"]');

            if(plusBtn) {
                e.preventDefault();
                addGift(
                    <HTMLElement>DOM.getMatched(plusBtn, '[data-basket="item-container"]'),
                    <HTMLElement>DOM.getMatched(plusBtn, '[data-basket="gift"]')
                );
                return;
            }
        }
    });

    basket.addEventListener('change', function(e) {
        let htmlTarget = e.target

        if(htmlTarget instanceof HTMLElement) {
            if(htmlTarget.matches('[data-basket="quantity-item"]')) {
                let basketItem = <HTMLElement>DOM.getMatched(htmlTarget, '[data-basket="item-container"]');
                updateGiftsNotice(basketItem);
                refreshGiftsButtons(basketItem);
                refreshPrices(<HTMLFormElement>basket);
                refreshQuantityCopy(basketItem);
                openChangeGiftIfNeeded(basketItem);
                return;
            }

            if(htmlTarget.matches('[data-basket="quantity-gift"]')) {
                let basketItem = <HTMLElement>DOM.getMatched(htmlTarget, '[data-basket="item-container"]');
                updateGiftQuantityOverleap(basketItem, <HTMLInputElement>htmlTarget);
                updateGiftsNotice(basketItem);
                refreshGiftsButtons(basketItem);
            }
        }
    });
}

function openChangeGiftIfNeeded(basketItem: HTMLElement): void {
    let availableGift = getAvailableGiftsQuantity(basketItem);

    if(availableGift < 0) {
        basketItem.querySelectorAll('[data-basket="quantity-gift"]').forEach(function(element: Element) {
            (<HTMLInputElement>element).value = '0';
        });
        changeGifts(basketItem);
    }
}

function refreshQuantityCopy(basketItem: HTMLElement): void {
    let quantityInput = (<HTMLInputElement>basketItem.querySelector('[data-basket="quantity-item"]'));
    let quantity = quantityInput.value;

    basketItem.querySelectorAll('[data-basket="quantity-copy"]').forEach(function(element: Element) {
        (<HTMLElement>element).textContent = quantity;
    })
}

function refreshPrices(basket: HTMLElement): void {
    let fullPrice = 0; let fullPriceVat = 0;

    basket.querySelectorAll('[data-basket="item-container"]').forEach(function(item: Element) {
        let quantity = Number((<HTMLInputElement>item.querySelector('[data-basket="quantity-item"]')).value);
        let itemPrice = <HTMLElement>(<HTMLElement>item.querySelector('[data-basket="price-item"]'));

        let price = Number(itemPrice.dataset.price) * quantity;
        let priceVat = Number(itemPrice.dataset.priceVat) * quantity;
        let currency = itemPrice.dataset.currency + '';

        fullPrice += price;
        fullPriceVat += priceVat;

        let options = { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 };
        let numberFormat = new Intl.NumberFormat('cs-CZ', options);

        itemPrice.textContent = numberFormat.format(priceVat);
    });

    let voucherContainer = (<HTMLElement|null>basket.querySelector('[data-basket="voucher-container"]'));

    if(voucherContainer !== null) {
        let voucherPriceElement = (<HTMLElement>voucherContainer.querySelector('[data-basket="price-item"]'));
        let voucherPrice = Number(voucherPriceElement.dataset.price);
        let voucherPriceVat = Number(voucherPriceElement.dataset.priceVat);
        fullPrice += voucherPrice;
        fullPriceVat += voucherPriceVat;
    }

    let finalPriceContainer = (<HTMLElement>basket.querySelector('[data-basket="final-price-container"]'));
    console.log(finalPriceContainer);
    let finalPriceSpan = (<HTMLSpanElement>finalPriceContainer.querySelector('[data-basket="price"]'));
    let finalPriceVatSpan = (<HTMLSpanElement>finalPriceContainer.querySelector('[data-basket="price-vat"]'));

    let options = { style: 'currency', currency: finalPriceSpan.dataset.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 };
    let numberFormat = new Intl.NumberFormat('cs-CZ', options);

    finalPriceSpan.textContent = numberFormat.format(fullPrice);
    finalPriceVatSpan.textContent = numberFormat.format(fullPriceVat);
}

function updateGiftQuantityOverleap(basketItem: HTMLElement, quantityInput: HTMLInputElement): void {
    let availableGift = getAvailableGiftsQuantity(basketItem);
    if(availableGift < 0) {
        quantityInput.value = (Number(quantityInput.value) + availableGift) + '';
    }
}

function addGift(basketItem: HTMLElement, gift: HTMLElement): void {
    let availableGift = getAvailableGiftsQuantity(basketItem);
    let input = <HTMLInputElement>gift.querySelector('[data-basket="quantity-gift"]');

    console.log(availableGift);
    if(availableGift > 0) {
        try {
            input.stepUp(1);
        }catch(ex){
            input.value = (Number(input.value) + 1) + '';
        }
    }

    refreshGiftsButtons(basketItem);
    updateGiftsNotice(basketItem);
}

function subGift(basketItem: HTMLElement, gift: HTMLElement): void {
    let input = <HTMLInputElement>gift.querySelector('[data-basket="quantity-gift"]');

    if(Number(input.value) > 0) {
        try {
            input.stepDown(1);
        }catch(ex){
            input.value = (Number(input.value) - 1) + '';
        }
    }

    refreshGiftsButtons(basketItem);
    updateGiftsNotice(basketItem);
}

function refreshGiftsButtons(basketItem: HTMLElement): void {
    let availableGift = getAvailableGiftsQuantity(basketItem);

    if(availableGift > 0) {
        basketItem.querySelectorAll('[data-basket="plus-gift"]').forEach(function(element: Element) {
            (<HTMLButtonElement>element).disabled = false;
        });
    } else {
        basketItem.querySelectorAll('[data-basket="plus-gift"]').forEach(function(element: Element) {
            (<HTMLButtonElement>element).disabled = true;
        });
    }

    basketItem.querySelectorAll('[data-basket="gift"]').forEach(function(element: Element) {
        let input = <HTMLInputElement>(element.querySelector('[data-basket="quantity-gift"]'));
        let btn = <HTMLButtonElement>(element.querySelector('[data-basket="minus-gift"]'));
        btn.disabled = Number(input.value) < 1;
    });
}

function getAvailableGiftsQuantity(basketItem: HTMLElement): number  {
    let itemQuantity = <HTMLInputElement>basketItem.querySelector('[data-basket="quantity-item"]');
    let itemQuantityValue = Number(itemQuantity.value);

    let giftsQuantity = 0;

    basketItem.querySelectorAll('[data-basket="quantity-gift"]').forEach(function(element: Element) {
        giftsQuantity += Number((<HTMLInputElement>element).value);
    })

    return itemQuantityValue - giftsQuantity;
}

function updateGiftsNotice(basketItem: HTMLElement): void {
    let notice = basketItem.querySelector('[data-basket="notice-gift"]');

    if(notice instanceof HTMLElement) {
        let availableGifts = getAvailableGiftsQuantity(basketItem);

        if(availableGifts > 0) {
            notice.classList.remove('d-none')
            notice.classList.add('d-inline-block');
            let noticeText = <HTMLSpanElement>notice.querySelector('span');
            if(availableGifts === 1) {
                noticeText.textContent = '1 dárek';
            } else if(availableGifts < 5) {
                noticeText.textContent = availableGifts + ' dárky';
            } else {
                noticeText.textContent = availableGifts + ' dárků';
            }
        } else {
            notice.classList.remove('d-inline-block');
            notice.classList.add('d-none')
        }
    }
}

function initializeGifts(basket: HTMLElement): void {
    basket.querySelectorAll('[data-basket="selected-gifts"]').forEach(function(element: Element) {
        (<HTMLElement>element).style.display = '';
    });

    basket.querySelectorAll('[data-basket="change-gifts"]').forEach(function(element: Element) {
        (<HTMLElement>element).style.display = '';
    });

    basket.querySelectorAll('[data-basket="available-gifts"]').forEach(function(element: Element) {
        (<HTMLElement>element).style.display = 'none';
    });

    basket.querySelectorAll('[data-basket="item-container"]').forEach(function(element: Element) {
        updateGiftsNotice(<HTMLElement>element);
        refreshGiftsButtons(<HTMLElement>element);
    });
}

function changeGifts(basketItem: HTMLElement) {
    basketItem.querySelectorAll('[data-basket="selected-gifts"]').forEach(function(element: Element) {
        (<HTMLElement>element).style.display = 'none';
    });

    basketItem.querySelectorAll('[data-basket="change-gifts"]').forEach(function(element: Element) {
        (<HTMLElement>element).style.display = 'none';
    });

    basketItem.querySelectorAll('[data-basket="available-gifts"]').forEach(function(element: Element) {
        (<HTMLElement>element).style.display = '';
    });

    updateGiftsNotice(basketItem);
    refreshGiftsButtons(basketItem);
}
